import type { Problem } from './i18n/errors'

/**
 * A failure, as the trader sees it: our sentence, and the guardian's own words under it.
 *
 * The fine print is deliberately not dropped. It is English, it is often the only thing that
 * distinguishes two failures with the same status, and it is what the trader reads out to the
 * operator. A screen that translates the headline and swallows the detail is a screen whose
 * errors cannot be reported.
 */
export function ProblemLine({ problem, className = 'bad' }: { problem: Problem; className?: string }) {
  return (
    <p className={className}>
      {problem.message}
      {problem.detail ? (
        <>
          {' '}
          <small className="muted">{problem.detail}</small>
        </>
      ) : null}
    </p>
  )
}
